import { Component, OnInit } from '@angular/core';
import {HomeService} from '../../_services/home.service';
@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {
  selected_month:any=""
  selected_year:any=""
  months:any=[
    {id:'01',name:'January'},
    {id:'02',name:'February'},
    {id:'03',name:'March'},
    {id:'04',name:'April'},
    {id:'05',name:'May'},
    {id:'06',name:'June'},
    {id:'07',name:'July'},
    {id:'08',name:'August'},
    {id:'09',name:'September'},
    {id:'10',name:'October'},
    {id:'11',name:'November'},
    {id:'12',name:'December'},
  ]
  year:any=[
    {id:'2021'},
    {id:'2022'},
    {id:"2023"}
  ]
  data:any={matka_game:[]};
  help:any;
  constructor(private homeService:HomeService) { }

  ngOnInit(): void {
      this.getToday();
    var date = new Date();
    var d = date.getDate();
    var month = date.getMonth();
    var year = date.getFullYear();
    this.selected_month = (month<10?'0'+month:""+month);
    this.selected_year = year;
    console.log(date, );
  }



  getToday(){
    this.homeService.getToday(this.selected_month, this.selected_year).subscribe((data) => {
      
      this.data = data;
      this.help = '91'+data.help.text;
      console.log(data);
    })
  }

}
